import * as Shadows from '../shadows';
import * as Borders from '../borders';

export default {
  paper: {
    border: Borders.GrayThinBorder,
    boxShadow: Shadows.DropdownMenuShadow,
  },
  list: {
    padding: '4px 0',
  },
};
